import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchAuthMe } from "../../../store/authSlice";
import authAPI from "../../../services/authApi";
import { HubFormCard, HubScreen } from "../AdminPortal/HubPwa";
import TrainerBrandingSettings from "../TrainerBrandingSettings";
import { Button, Field, Input, useToast } from "../../ui";

export default function StaffProfileSettings() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const toast = useToast();
  const { profile } = useSelector((state) => state.auth);
  const [form, setForm] = useState({ full_name: "", phone: "" });
  const [pwd, setPwd] = useState({ current: "", next: "" });
  const [saving, setSaving] = useState(false);
  const [pwdSaving, setPwdSaving] = useState(false);

  useEffect(() => {
    setForm({
      full_name: profile?.full_name || "",
      phone: profile?.phone || "",
    });
  }, [profile]);

  const saveProfile = async () => {
    setSaving(true);
    try {
      await authAPI.updateMyAccount({
        full_name: form.full_name,
        phone: form.phone,
      });
      await dispatch(fetchAuthMe());
      toast.success("Сохранено");
    } catch (e) {
      toast.error(e.response?.data?.error || "Ошибка сохранения");
    } finally {
      setSaving(false);
    }
  };

  const savePassword = async () => {
    if (!pwd.current || !pwd.next) {
      toast.error("Заполните оба поля пароля");
      return;
    }
    setPwdSaving(true);
    try {
      await authAPI.changePassword(pwd.current, pwd.next);
      setPwd({ current: "", next: "" });
      toast.success("Пароль изменён");
    } catch (e) {
      toast.error(e.response?.data?.error || "Ошибка");
    } finally {
      setPwdSaving(false);
    }
  };

  return (
    <HubScreen
      title="Расширенные настройки"
      onBack={() => navigate("/staff/app/profile")}
      backLabel="Профиль"
    >
      <HubFormCard title="Мои данные">
        <Field label="Имя">
          <Input
            value={form.full_name}
            onChange={(e) => setForm({ ...form, full_name: e.target.value })}
          />
        </Field>
        <Field label="Телефон">
          <Input
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
          />
        </Field>
        <Field label="Email">
          <Input value={profile?.email || ""} readOnly />
        </Field>
        <Button type="button" onClick={saveProfile} disabled={saving}>
          {saving ? "Сохранение…" : "Сохранить"}
        </Button>
      </HubFormCard>

      <HubFormCard title="Оформление для клиентов">
        <TrainerBrandingSettings embedded />
      </HubFormCard>

      <HubFormCard title="Пароль">
        <Field label="Текущий пароль">
          <Input
            type="password"
            value={pwd.current}
            onChange={(e) => setPwd({ ...pwd, current: e.target.value })}
          />
        </Field>
        <Field label="Новый пароль">
          <Input
            type="password"
            value={pwd.next}
            onChange={(e) => setPwd({ ...pwd, next: e.target.value })}
          />
        </Field>
        <Button
          type="button"
          onClick={savePassword}
          disabled={pwdSaving}
          variant="secondary"
        >
          {pwdSaving ? "…" : "Сменить пароль"}
        </Button>
      </HubFormCard>
    </HubScreen>
  );
}
